import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { BSKT_DanhSachSinhVienLop_ViewModel } from '../../services/danh-sach-sinh-vien-lop-bskt/DanhSachSinhVienLopBSKTModels';
import { BSKT_Lop_TreeView_Item } from '../../services/lop/LopModels';

interface DanhSachLopState {
    listData: BSKT_DanhSachSinhVienLop_ViewModel[];
    selectedId: number | null;
    status: 'idle' | 'loading' | 'succeeded' | 'failed';
    isShowConfirmDeleteModal: boolean;
    selectedLopHocId: number | null;
    selectedLopHocItem?: BSKT_Lop_TreeView_Item | undefined;
}

const initialState: DanhSachLopState = {
    listData: [],
    selectedId: null,
    status: 'idle',
    isShowConfirmDeleteModal: false,
    selectedLopHocId: 0,
    selectedLopHocItem: undefined
};

const danhSachLopSlice = createSlice({
    name: 'danhSachLop',
    initialState,
    reducers: {
        setHocVienList: (state, action: PayloadAction<BSKT_DanhSachSinhVienLop_ViewModel[]>) => {
            state.listData = action.payload;
        },
        setListHocVienVaoLop: (state, action: PayloadAction<BSKT_DanhSachSinhVienLop_ViewModel[]>) => {
            state.listData = [...state.listData, ...action.payload];
        },
        setDanhSachLopStatus: (state, action: PayloadAction<DanhSachLopState['status']>) => {
            state.status = action.payload;
        },
        deleteHocVienSuccess: (state, action: PayloadAction<number>) => {
            state.listData = state.listData.filter((x) => x.ID_thi_sinh !== action.payload);
            state.isShowConfirmDeleteModal = false;
        },
        setSelectedHocVienId: (state, action: PayloadAction<number | null>) => {
            state.selectedId = action.payload;
        },
        setShowConfirmDeleteModal: (state, action: PayloadAction<{ show: boolean; id?: number }>) => {
            state.isShowConfirmDeleteModal = action.payload.show;
            state.selectedId = action.payload.id ?? null;
        },
        setSelectLopHocId: (state, action: PayloadAction<number>) => {
            state.selectedLopHocId = action.payload;
        },
        setSelectLopHocItem: (state, action: PayloadAction<BSKT_Lop_TreeView_Item | undefined>) => {
            state.selectedLopHocItem = action.payload;
        },
        resetDanhSachLopState: () => initialState
    }
});

export const {
    setHocVienList,
    setListHocVienVaoLop,
    setDanhSachLopStatus,
    deleteHocVienSuccess,
    setSelectedHocVienId,
    setShowConfirmDeleteModal,
    resetDanhSachLopState,
    setSelectLopHocId,
    setSelectLopHocItem
} = danhSachLopSlice.actions;

export const DanhSachLopReducer = danhSachLopSlice.reducer;
